/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
/* Services */

/**
 * Renders SadhguruSignatureLoveGrace Component
 *
 * @param {object} Card
 * @returns {ReactElement} SadhguruSignatureLoveGrace Component
 */

const MsrImageSlider = ({ sectionContent }) => {
    const NextArrow = props => {
        const { onClick } = props;
        return (
          <Box
            pos="absolute"
            top="40%"
            zIndex="10"
            cursor="pointer"
            bgSize="60px"
            bgColor="transparent"
            border="0"
            borderRadius="0"
            w={{base:'32px', md:'40px'}}
            h={{base:'32px', md:'40px'}}
            bgPos="center"
            bgRepeat="no-repeat"
            color="transparent"
            bgImage={`url(${config.imgPath}/d/46272/1719906048-icon_sliderrightarrow.png)`}
            right={{base:'-15px', md:'-15px'}}
            onClick={onClick}
          >
          </Box>
        );
    };

  const PrevArrow = props => {
    const { onClick } = props;
    return (
      <Box
        pos="absolute"
        top="40%"
        zIndex="17"
        cursor="pointer"
        bgSize="60px"
        bgImage={`url(${config.imgPath}/d/46272/1719906063-icon_sliderleftarrow.png)`}
        bgColor="transparent"
        border="0"
        borderRadius="0"
        w={{base:'32px', md:'40px'}}
        h={{base:'32px', md:'40px'}}
        bgPos="center"
        bgRepeat="no-repeat"
        color="transparent"
        left={{base:'-15px', md:'-15px'}}
        onClick={onClick}
      >
      </Box>
    );
  };

  const settings = {
    dots: false,
    autoplay: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    customPaging: function (i) {
      return (
        <Text
          cursor="pointer"
          display="inline-block"
          w="10px"
          className="dots-slider"
          h="10px"
          m={{ base: '40px 8px 0 8px', md: '25px 8px 0 8px' }}
          bgColor="#C0955F"
          borderRadius="50%"
        />
      );
    },
  };
  return (
    <Box width={{base:'90%', md:'auto'}} m="0 auto" pt="20px">
      <Slider {...settings}>
        {sectionContent &&
            sectionContent.map((img, i) => {
            return (
                <Box key={i} pos="relative" width="100%">
                    <LazyLoadImageComponent
                        alt={img?.alt}
                        title={img?.alt}
                        src={img?.url}
                        minHeight={{
                        base: '192px',
                        sm: '192px',
                        md: '423px',
                        }}
                        width={{base:'100%', md:'755px'}}
                    />
                </Box>
            );
            })}
        </Slider>
    </Box>
  );
};

export default MsrImageSlider;
